import { combineReducers } from "redux";
import commonReducer from "@redux/feature/Markets/Common/Reducers/commonReducer";
import EqOrderBookReducer from "./eqOrderBook";
export default combineReducers({
    reducersData: EqOrderBookReducer,
    commonData: commonReducer,
});
